module.exports = __webpack_public_path__ + "img/ic_publicity_detail7_1.4e613d7c.jpg";